/**
 * Fluidic Theme - Main JavaScript
 */

import './components/hero-slider';
import './components/contact-form';
import initHeaderNav from './components/header-nav';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
document.addEventListener('DOMContentLoaded', function() {
    AOS.init({
        duration: 1000,
        once: true,
        offset: 100,
    });

    // Inicializar navegação do header
    initHeaderNav();

    // Assistência Técnica - Slider removido, agora é uma lista vertical

    // Produtos Slider (apenas no mobile)
    const produtosSlider = document.querySelector('.produtos-slider');
    if (produtosSlider && typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        // Função para verificar se está no mobile
        const isMobile = () => window.innerWidth <= 767;
        
        // Função para inicializar/destruir o slider baseado no tamanho da tela
        const handleProdutosSlider = () => {
            if (isMobile()) {
                // Se já está inicializado, não faz nada
                if (!jQuery(produtosSlider).hasClass('slick-initialized')) {
                    jQuery(produtosSlider).slick({
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 1.1,
                        slidesToScroll: 1,
                        autoplay: false,
                        arrows: false,
                        centerMode: false,
                        variableWidth: false,
                    });
                }
            } else {
                // Se está no desktop e o slider foi inicializado, destroi
                if (jQuery(produtosSlider).hasClass('slick-initialized')) {
                    jQuery(produtosSlider).slick('unslick');
                }
            }
        };

        // Inicializar na carga
        handleProdutosSlider();

        // Reagir a mudanças de tamanho da janela
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleProdutosSlider, 250);
        });
    }
});

